module.exports = __webpack_public_path__ + "images/emoji/facepunch.5546128762e3d535da1f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/facepunch.png
// module id = 2tbd
// module chunks = 13